import React from 'react';

const SUPPORT_PHONE = '337-912-0948';
const SUPPORT_PHONE_URI = `tel:+1${SUPPORT_PHONE.replace(/\D/g, '')}`;
const SUPPORT_EMAIL = 'support@dataflyt.com';

type ContactProps = Omit<React.AnchorHTMLAttributes<HTMLAnchorElement>, 'href' | 'children'>;
type EmailProps = ContactProps & { subject?: string; body?: string };

export function DataflytContactPhone(props: ContactProps) {
    return <a {...props} href={SUPPORT_PHONE_URI}>{SUPPORT_PHONE}</a>;
}

/** Encode each mailto field separately so user-provided text cannot add parameters. */
export function DataflytContactEmail({ subject, body, ...props }: EmailProps) {
    const parameters = [];
    if (subject) parameters.push(`subject=${encodeURIComponent(subject)}`);
    if (body) parameters.push(`body=${encodeURIComponent(body)}`);
    const query = parameters.length ? `?${parameters.join('&')}` : '';
    return <a {...props} href={`mailto:${SUPPORT_EMAIL}${query}`}>{SUPPORT_EMAIL}</a>;
}
